import {useKeycloak} from '@react-keycloak/web';


/**
 * @param role {string} Role to check
 * @returns {boolean} True if no role given or role has access; false if not
 */
function hasRole(role) {

    const {keycloak} = useKeycloak();

    return !role || keycloak.hasRealmRole(role);
}


export default hasRole;
